import React from 'react';

const RequiredNoteGray = (props) =>{
    return (<span style={{color: "#7d7d7c"}}>*</span>)
}

export default RequiredNoteGray;